import GlpFormRender from './GlpFormRender.vue'

export { GlpFormRender }
